import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import 'cross-fetch/polyfill';
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client';
import Cookie from 'universal-cookie';
import { InMemoryCache } from 'apollo-cache-inmemory';
Vue.use(VueApollo);
export default ((ctx, inject) => {
  const providerOptions = {
    clients: {}
  };
  const {
    app,
    beforeNuxtRender,
    req
  } = ctx;
  const AUTH_TOKEN_NAME = 'apollo-token';
  const COOKIE_ATTRIBUTES = {
    "expires": 7,
    "path": "\u002F",
    "secure": false
  };
  const AUTH_TYPE = 'Bearer ';
  const cookies = new Cookie(req && req.headers.cookie); // Config

  const defaultTokenName = '' || AUTH_TOKEN_NAME;

  function defaultGetAuth() {
    const token = cookies.get(defaultTokenName);
    return token && defaultClientConfig.validateToken(token) ? AUTH_TYPE + token : '';
  }

  let defaultClientConfig;
  defaultClientConfig = require('~/plugins/apollo-config');

  if ('default' in defaultClientConfig) {
    defaultClientConfig = defaultClientConfig.default;
  }

  defaultClientConfig = defaultClientConfig(ctx);

  const defaultValidateToken = () => true;

  if (!defaultClientConfig.validateToken) {
    defaultClientConfig.validateToken = defaultValidateToken;
  }

  const defaultCache = defaultClientConfig.cache ? defaultClientConfig.cache : new InMemoryCache(defaultClientConfig.inMemoryCacheOptions ? defaultClientConfig.inMemoryCacheOptions : undefined);

  if (!process.server) {
    defaultCache.restore(window.__NUXT__ ? window.__NUXT__.apollo.defaultClient : null);
  }

  if (!defaultClientConfig.getAuth) {
    defaultClientConfig.getAuth = defaultGetAuth;
  }

  if (process.client && defaultClientConfig.browserHttpEndpoint) {
    defaultClientConfig.httpEndpoint = defaultClientConfig.browserHttpEndpoint;
  }

  defaultClientConfig.ssr = !!process.server;
  defaultClientConfig.cache = defaultCache;
  defaultClientConfig.tokenName = defaultTokenName; // if ssr we'd still like to have our webclient's cookies

  if (process.server && req && req.headers && req.headers.cookie) {
    if (!defaultClientConfig.httpLinkOptions) {
      defaultClientConfig.httpLinkOptions = {};
    }

    if (!defaultClientConfig.httpLinkOptions.headers) {
      defaultClientConfig.httpLinkOptions.headers = {};
    }

    defaultClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie;
  } // Create apollo client


  let defaultApolloCreation = createApolloClient(_objectSpread({}, defaultClientConfig));
  defaultApolloCreation.apolloClient.wsClient = defaultApolloCreation.wsClient;
  providerOptions.defaultClient = defaultApolloCreation.apolloClient;
  const vueApolloOptions = Object.assign(providerOptions, {
    errorHandler(error) {
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message);
    }

  });
  const apolloProvider = new VueApollo(vueApolloOptions); // Allow access to the provider in the context

  app.apolloProvider = apolloProvider;

  if (process.server) {
    const ApolloSSR = require('vue-apollo/ssr');

    beforeNuxtRender((_ref) => {
      let {
        nuxtState
      } = _ref;
      nuxtState.apollo = ApolloSSR.getStates(apolloProvider); // Clear apollo client cache after each request
      // Issues: https://github.com/nuxt-community/apollo-module/issues/273
      //         https://github.com/nuxt-community/apollo-module/issues/251

      Object.values(apolloProvider.clients).forEach(client => client.cache.reset());
    });
  }

  inject('apolloHelpers', {
    onLogin: function () {
      var _onLogin = _asyncToGenerator(function* (token) {
        let apolloClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : apolloProvider.defaultClient;
        let cookieAttributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : COOKIE_ATTRIBUTES;
        let skipResetStore = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        // Fallback for tokenExpires param
        if (typeof cookieAttributes === 'number') cookieAttributes = {
          expires: cookieAttributes
        };

        if (typeof cookieAttributes.expires === 'number') {
          cookieAttributes.expires = new Date(Date.now() + 86400 * 1000 * cookieAttributes.expires);
        }

        if (token) {
          cookies.set(AUTH_TOKEN_NAME, token, cookieAttributes);
        } else {
          cookies.remove(AUTH_TOKEN_NAME, cookieAttributes);
        }

        if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);

        if (!skipResetStore) {
          try {
            yield apolloClient.resetStore();
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log('%cError on cache reset (setToken)', 'color: orange;', e.message);
          }
        }
      });

      function onLogin(_x) {
        return _onLogin.apply(this, arguments);
      }

      return onLogin;
    }(),
    onLogout: function () {
      var _onLogout = _asyncToGenerator(function* () {
        let apolloClient = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : apolloProvider.defaultClient;
        let skipResetStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        cookies.remove(AUTH_TOKEN_NAME, COOKIE_ATTRIBUTES);
        if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);

        if (!skipResetStore) {
          try {
            yield apolloClient.resetStore();
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log('%cError on cache reset (logout)', 'color: orange;', e.message);
          }
        }
      });

      function onLogout() {
        return _onLogout.apply(this, arguments);
      }

      return onLogout;
    }(),
    getToken: function getToken() {
      let tokenName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AUTH_TOKEN_NAME;
      return cookies.get(tokenName);
    }
  });
});